module.exports = __webpack_public_path__ + "static/media/isdoctorplan-gastro2@3x.5e43bd98.png";